module.exports = __webpack_public_path__ + "img/12-10.c4a01557.png";